// extracted by mini-css-extract-plugin
module.exports = {"main":"taxation_main__3odVp","title":"taxation_title__37ZXj","grid":"taxation_grid__1pGZW"};